export default __webpack_public_path__ + "static/desktop-home-map-static-img-1225e18c37492c22895b6197d782f9c7.jpg";